import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=2e35960c&scoped=true"
import script from "./EmailDialog.vue?vue&type=script&lang=js"
export * from "./EmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35960c",
  null
  
)

export default component.exports